/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplateCosoPrincipioDTO} from './TemplateCosoPrincipioDTO';

/**
 * The TemplateCosoFattoreQualificanteDTO model module.
 * @module model/TemplateCosoFattoreQualificanteDTO
 * @version v0
 */
export class TemplateCosoFattoreQualificanteDTO {
  /**
   * Constructs a new <code>TemplateCosoFattoreQualificanteDTO</code>.
   * @alias module:model/TemplateCosoFattoreQualificanteDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateCosoFattoreQualificanteDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateCosoFattoreQualificanteDTO} obj Optional instance to populate.
   * @return {module:model/TemplateCosoFattoreQualificanteDTO} The populated <code>TemplateCosoFattoreQualificanteDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateCosoFattoreQualificanteDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('templateCosoPrincipi'))
        obj.templateCosoPrincipi = ApiClient.convertToType(data['templateCosoPrincipi'], [TemplateCosoPrincipioDTO]);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
TemplateCosoFattoreQualificanteDTO.prototype.id = undefined;

/**
 * @member {String} title
 */
TemplateCosoFattoreQualificanteDTO.prototype.title = undefined;

/**
 * @member {Number} position
 */
TemplateCosoFattoreQualificanteDTO.prototype.position = undefined;

/**
 * @member {Array.<module:model/TemplateCosoPrincipioDTO>} templateCosoPrincipi
 */
TemplateCosoFattoreQualificanteDTO.prototype.templateCosoPrincipi = undefined;

